<div style="width: 100%; position: relative">
    <rask-map [settings]="mapsettings" [refresh]="refresh" [filter]="filter">
        <rask-map-home [extent]="currentAoExtent"></rask-map-home>
        <rask-map-select [hidden]="!!selectedArbetsorder" geotypes="arbetsordrar">
        </rask-map-select>
        <rask-map-draw [enabled]="canEdit()"></rask-map-draw>
        <rask-map-extent
            [hidden]="!selectedArbetsorder"
            [enabled]="!!selectedArbetsorder"
            (extentUpdated)="extentUpdated($event)"
            (extentRemoved)="extentRemoved($event)"
            [config]="extentConfig">
        </rask-map-extent>
        <rask-map-measure></rask-map-measure>
        <rask-map-fullscreen></rask-map-fullscreen>
        <rask-map-layers [refresh]="settings"></rask-map-layers>
    </rask-map>
</div>